<template>
  <el-button
    v-if="!text"
    type="default"
    :size="size"
    :class="[openerClass, exportClass]"
    v-on="$listeners"
    @click="onClick"
    :data-id="dataId || id"
  >
    <slot />
  </el-button>
  <div v-else :class="[openerClass, exportClass]" v-on="$listeners" @click="onClick" class="w-100">
    <slot />
  </div>
</template>

<script>
/**
 * @param Opener
 *
 * @description Az oldalakon a felugró ablakok vezérlése
 */
import { mapActions } from 'vuex'

export default {
  name: 'ModalOpener',
  props: {
    id: {
      type: String,
    },
    dataId: {
      type: String,
    },
    text: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
    exportClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    openerClass() {
      return this.text ? 'bare-link' : 'btn'
    },
  },
  methods: {
    ...mapActions(['showModal']),
    onClick() {
      if (this.disabled) return
      this.showModal({ id: this.id, params: this.params })
    },
  },
}
</script>
<style>
.bare-link {
  background: none;
  border: none !important;
  padding: 0;
}
</style>
